<template>
    <TableRow @dblclick="toggleHover"
        :isSelected="isSelected" class="transition-all duration-300" :class="[{'cursor-wait': loadingCompany}]"
    >
        <TableCell>
            <div @click="openModal" @mouseenter="showExpand" @mouseleave="hideExpand" class="flex justify-start items-center p-2  hover:cursor-pointer">
                <div class="whitespace-nowrap grid grid-cols-3 gap-1 w-full">
                    <div v-if="expandVisible" class="p-1.5 rounded-full hover:bg-indigo-200">
                        <ExpandSVG />
                    </div>
                    <div class="flex items-center" v-else>
                        {{ person.id }}
                    </div>
                        <base-icon-popover-hover v-if="person.user_has_photos"
                            class=" border p-1 bg-green-200"
                            popoverTitle="Photos"
                            popoverBody="User has uploaded photos."
                        >
                            <PhotoSVG icon-class="w-3 h-3" fill="none" />
                        </base-icon-popover-hover>
                        <base-icon-popover-hover v-else
                            class=" border p-1 bg-gray-300"
                            popoverTitle="Photos"
                            popoverBody="User has not uploaded photos."
                        >
                            <MinusSVG icon-class="w-3 h-3" stroke-color="black" fill="black" />
                        </base-icon-popover-hover>
                        <base-icon-popover-hover v-if="photoConsent == 'none' || !photoConsent"
                            class=" border border-gray-300 p-1 bg-gray-300"
                            popoverTitle="Photo Consent"
                            popoverBody="User has not filled out photo consent form."
                        >
                            <MinusSVG icon-class="w-3 h-3" stroke-color="black" fill="black" />
                        </base-icon-popover-hover>
                        <base-icon-popover-hover v-else-if="photoConsent == 'consent'"
                            class=" border p-1 bg-green-200"
                            popoverTitle="Photo Consent"
                            popoverBody="User has consented to photo usage."
                        >
                            <CameraSVG icon-class="w-3 h-3" fill="none" />
                        </base-icon-popover-hover>
                        <base-icon-popover-hover v-else-if="photoConsent == 'non-consent'"
                            class=" border p-1 bg-red-100"
                            popoverTitle="Photo Consent"
                            popoverBody="User has opted not to consent to photo usage."
                        >
                             <BanSVG icon-class="w-3 h-3" fill="#441306" />
                        </base-icon-popover-hover>
                </div>
            </div>

        </TableCell>
        <TableCell >
            <div :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full p-2">
                {{ person.first_name }}
            </div>
        </TableCell>
        <TableCell >
            <div :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full p-2">
                {{ person.last_name }}
            </div>
        </TableCell>
        <TableCell >
            <div v-if="user" :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full p-2">
                {{ username }}
            </div>
            <div v-else :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full p-2">
                <div v-if="hasWhitelistedEmail" class="flex flex-col gap-1">
                    <div class="p-0.5 bg-yellow-200">
                        Waiting for user registration
                    </div>
                    <!-- <base-button-affirmative @click="showAdminCreateUserForm">
                        Admin Create User
                    </base-button-affirmative> -->
                </div>
                <div v-else class="flex w-full justify-between">
                    <!-- <div class="w-1/2"> -->
                        <base-button-affirmative @click="showWhitelistEmailForm">
                            Send Registration
                        </base-button-affirmative>
                    <!-- </div> -->
                    <!-- <div class="w-1/2"> -->
                        <base-button-affirmative @click="showAdminCreateUserForm">
                            Create User
                        </base-button-affirmative>
                    <!-- </div> -->
                </div>
            </div>
            <base-modal :is-form-visible="whitelistEmailFormVisible" @close="closeWhitelistEmailForm">
                <template v-slot:header> {{ person.first_name }} {{ person.last_name }} Aerocle ID: {{ person.id }} </template>
                <template v-slot:body>
                    <WhitelistEmailForm :person="person" @close="closeWhitelistEmailForm" />
                </template>
            </base-modal>
            <base-modal :is-form-visible="adminCreateUserFormVisible" @close="closeAdminCreateUserForm">
                <template v-slot:header> Admin Create User — {{ person.first_name }} {{ person.last_name }} (ID: {{ person.id }}) </template>
                <template v-slot:body>
                    <AdminCreateUserForm :person="person" @close="closeAdminCreateUserForm" @refetch-people="fetchNewPeople" />
                </template>
            </base-modal>
        </TableCell>
        <TableCell >
            <div :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full flex flex-col p-2">
                <div class="">
                   Aerocle: {{ userEmail }}
                </div>
                <div v-for="email in person.email_addresses" :key="email.id" class="">
                   {{ email.description }}: {{ email.email_address }}
                </div>
            </div>
        </TableCell>
        <TableCell >
            <div :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full flex justify-between items-center p-2">
                <div>
                    {{ isActive }}
                </div>
                <div v-if="user && isDevOrMgmt" class="pr-2">
                    <base-button-negative @click="stopUser" v-if="user.is_active" class="">
                        <StopSVG stroke="white" />
                    </base-button-negative>
                    <base-button-affirmative @click="startUser" v-else class="">
                        <PlaySVG stroke="white" />
                    </base-button-affirmative>
                </div>
            </div>
        </TableCell>
        <TableCell v-if="isDevOrMgmt">
            <div @click="openExportLimitsForm" :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full p-2 hover:cursor-pointer">
                <div class="flex flex-col" v-if="user && user.csv_export_limit">
                    <div class="flex w-full justify-between">
                        <div>
                            Individual: 
                        </div>
                        <div>
                            {{ individualLimit }}
                        </div>
                    </div>
                    <div class="flex w-full justify-between">
                        <div>
                            30 day: 
                        </div>
                        <div>
                            {{ thirtyDayLimit }}
                        </div>
                    </div>
                </div>
                <div v-else>
                    --
                </div>
            </div>
        </TableCell>
        <TableCell >
            <div @click="openWorkflow" :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all hover:cursor-pointer duration-300 w-full p-2">
                <MissingUserWorkflowSteps :person="person" :workflow-steps="workflowSteps" />
            </div>
            
    <base-modal :is-form-visible="isModalVisible" @close="closeUserModal">
      <template v-slot:header> {{ person.first_name }} {{ person.last_name }} Aerocle ID: {{ person.id }} </template>
      <template v-slot:body>
        <PersonModal
          :user="user"
          :person="person"
          :default-tab="defaultTab"
          :groups="groups"
          :workflow-steps="workflowSteps"
          @refetch-people="fetchNewPeople"
          @close="closeUserModal"
          addOrEdit="edit"
        />
      </template>
    </base-modal>
        </TableCell>
        <!-- <TableCell >
            <div :class="[{'truncate': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all duration-300 w-full p-2">
                {{ lastLogin }}
            </div>
        </TableCell> -->
        <TableCell v-if="isDevOrMgmt">
            <div :class="[{'line-clamp-2': truncating}, {'max-h-10' : !hovering, 'max-h-96': hovering}]" class="transition-all whitespace-pre-wrap duration-300 w-full p-2 flex flex-col">
                {{ userGroups }}
            </div>
        </TableCell>
    </TableRow>
</template>

<script setup>
import {ref, defineProps, defineEmits, computed, watch } from "vue";
import { useStore } from "vuex";
import TableRow from '@/components/base-components/TableRow.vue';
import TableCell from '@/components/base-components/TableCell.vue';
import { useToast } from 'vue-toast-notification';
import { formatDateTime } from "@/composables/formatDateTime";
import PersonModal from "./PersonModal.vue";
import MissingUserWorkflowSteps from "./MissingUserWorkflowSteps.vue";
import ExpandSVG from "../svg-components/ExpandSVG.vue";
import PlaySVG from "../svg-components/PlaySVG.vue";
import StopSVG from "../svg-components/StopSVG.vue";
import { deactivateUser, activateUser } from "@/services/User";
import WhitelistEmailForm from "./WhitelistEmailForm.vue";
import AdminCreateUserForm from "./AdminCreateUserForm.vue";
import PhotoSVG from "../svg-components/PhotoSVG.vue";
import CameraSVG from "../svg-components/CameraSVG.vue";
import MinusSVG from "../svg-components/MinusSVG.vue";
import BanSVG from "../svg-components/BanSVG.vue";


const store = useStore()
const $toast = useToast()

const props = defineProps([
    'person',
    'selectAll',
    'isLoading',
    'workflowSteps',
    'groups',
    'userPermissions'
])

const user = computed(() => {
    return props.person.user
})

const username = computed(() => {
    if(user.value){
        return user.value.username
    } else {
        return '--'
    }
})

const userEmail = computed(() => {
    if(user.value){
        return user.value.email
    } else {
        return '--'
    }
})

const isDevOrMgmt = computed(() => {
    return props.userPermissions.isDev || props.userPermissions.isManagement || props.userPermissions.isSuperUser
})

const isActive = computed(() => {
    if(user.value){
        return user.value.is_active
    } else {
        return '--'
    }
})

const photoConsent = computed(() => {
    return props.person.user_photo_consent_status
})

const hasWhitelistedEmail = computed(() => {
    return props.person.email_addresses.filter((email) => email.is_whitelisted).length > 0
})

const individualLimit = computed(() => {
    if(user.value){
        return user.value.csv_export_limit.individual_export_limit
    } else {
        return null
    }
})

const thirtyDayLimit = computed(() => {
    if(user.value){
        return user.value.csv_export_limit.thirty_day_export_limit
    } else {
        return null
    }
})

const personalEmail = computed(() => {
    if(props.person.personal_email){
        return props.person.personal_email
    } else {
        return '--'
    }
})

const defaultTab = ref(null)
const whitelistEmailFormVisible = ref(false)
const adminCreateUserFormVisible = ref(false)

function showWhitelistEmailForm(){
    whitelistEmailFormVisible.value = true
}

function closeWhitelistEmailForm(){
    whitelistEmailFormVisible.value = false
}

function showAdminCreateUserForm(){
    adminCreateUserFormVisible.value = true
}

function closeAdminCreateUserForm(){
    adminCreateUserFormVisible.value = false
}

const emit = defineEmits([
    'refetch-results', 
    'loading',
    'delete-inventory-item'
])

function fetchNewPeople(){
    emit('refetch-results')
}

async function stopUser(){
    const token = store.state.auth.token
    const result = await deactivateUser(token, user.value.id)
    if(result.status == 200){
        fetchNewPeople()
        $toast.open({
            message: `Successfully deactivated ${user.value.username}`,
            type: 'success',
            duration: 3000
        })
    } else {
        $toast.open({
            message: `Error, could not deactivate ${user.value.username}`,
            type: 'error',
            duration: 3000
        })
    }
}

async function startUser(){
    const token = store.state.auth.token
    const result = await activateUser(token, user.value.id)
    if(result.status == 200){
        fetchNewPeople()
        $toast.open({
            message: `Successfully activated ${user.value.username}`,
            type: 'success',
            duration: 3000
        })
    } else {
        $toast.open({
            message: `Error, could not activate ${user.value.username}`,
            type: 'error',
            duration: 3000
        })
    }
}


// const rejectionReason = ref(props.companyCampaignChangeRequest.rejection_reason)
const loadingCompany = ref(false)
const isSelected = ref(props.selectAll)
const visibleSelectBox = ref(false)
const isModalVisible = ref(false)
const expandVisible = ref(false)

function showExpand(){
    expandVisible.value = true 
}

function hideExpand(){
    expandVisible.value = false
}

function openModal(){
    isModalVisible.value = true
}

function openWorkflow(){
    isModalVisible.value = true
    defaultTab.value = "Workflow"
}

function openExportLimitsForm(){
    defaultTab.value = 'Export Limits'
    isModalVisible.value = true
}

function closeUserModal(){
    isModalVisible.value = false
    defaultTab.value = null
}

const lastLogin = computed(() => {
    return formatDateTime(user.value.last_login)
})

watch(() => props.selectAll, () => {
    isSelected.value = props.selectAll
    if(props.selectAll) {
        showSelectBox()
        // emit('add-selected-company-campaign-change-request', props.companyCampaignChangeRequest)
    } else if (!props.selectAll) {
        hideSelectBox()
        // emit('remove-selected-company-campaign-change-request', props.companyCampaignChangeRequest)
    }
})

const userGroups = computed(() => {
    if(user.value && user.value.groups.length > 0){
        return user.value.groups.map(group => group.name).join('\n')
    } else {
        return '--'
    }
})


function refetchResults() {
    emit('refetch-results')
}


function showSelectBox() {
    visibleSelectBox.value = true
}

function hideSelectBox() {
    if(!props.selectAll & !isSelected.value) {
        visibleSelectBox.value = false
    }
}
const hovering = ref(false)
const shouldExpand = ref(false)
const truncating = ref(true)

function setHoverTrue(){
    shouldExpand.value = true
    setTimeout(() => {
        if(shouldExpand.value){
            hovering.value = true 
        }
    }, 750)
}

function toggleHover(){
    hovering.value = !hovering.value
}

watch(hovering, () => {
    if(hovering.value) {
        truncating.value = false
    } else {
        setTimeout(() => {
            truncating.value = true
        }, 300)

    }
})



</script>